<template>
    <div class="col mx-sm-9 mx-0">

        <div class="progress">
            <div class="progress-bar progress-bar-striped progress-bar-animated bg-warning" role="progressbar"
                aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" :style="'width: ' + percent + '%'">
            </div>
        </div>
        <div v-if="!isMobile()" class="row my-3">
            <div class="col">Pilih Haiwan</div>
            <div class="col">Pilih Kawasan</div>
            <div class="col">Pilih Pakej</div>
            <div class="col">Bilangan</div>
            <div class="col">Butiran Pembeli</div>
            <div class="col">Butiran Peserta</div>
            <div class="col">Kaedah Pembayaran</div>
            <div class="col">Lafaz Akad</div>
        </div>
        <form ref="form" :action="routeStore" method="POST" @submit="onSubmit">
            <input type="hidden" name="_token" :value="csrf" />
            <div class="col my-6 px-0">
                <div class="col d-flex justify-content-between px-0 py-2">
                    <div class="col px-0">
                        <button v-if="progress != 0" v-on:click="back()" class="btn btn-md"
                            style="border-color: #888888; color: #888888; border-radius: 10px;"><i
                                class="fe fe-chevron-left"></i> Kembali </button>
                    </div>
                    <div v-if="progress != 7" class="col px-0" align="right">
                        <button v-on:click="next()" :disabled="nextButton" class="btn btn-md text-white"
                            style="background-color: #216A35; border-radius: 10px;"> Teruskan <i
                                class="fe fe-chevron-right"></i></button>
                    </div>
                </div>
                <div v-if="progress == 0" align="center">
                    <label class="border rounded p-4 m-2" align="center"
                        style="height: 300px; width: 250px; background-color: #ffffff">
                        <img class="my-4" src="/img/gambar_kambing_kurban_2024.png">
                        <input type="radio" name="korbanType" value="kambing" v-model="korbanType" class="mr-3">
                        Kambing
                    </label>
                    <label class="border rounded p-4 m-2" align="center"
                        style="height: 300px; width: 250px; background-color: #ffffff">
                        <img class="my-4" src="/img/gambar_lembu_kurban_2024.png">
                        <input type="radio" name="korbanType" value="lembu" v-model="korbanType" class="mr-3">
                        Lembu
                    </label>
                </div>
                <div v-if="progress == 1" align="center">
                    <label class="border rounded p-4 m-2" align="center"
                        style="height: 300px; width: 270px; background-color: #ffffff">
                        <img class="mt-7 mb-6" src="/img/map_malaysia.svg">
                        <br>
                        <input type="radio" name="locality" value="malaysia" v-model="locality">
                        Malaysia
                    </label>
                    <label class="border rounded p-4 m-2" align="center"
                        style="height: 300px; width: 270px; background-color: #ffffff">
                        <img class="mt-7 mb-6" src="/img/map_global.svg" style="width: 200px">
                        <br>
                        <input type="radio" name="locality" value="global" v-model="locality">
                        Luar Malaysia
                    </label>
                </div>

                <div v-if="progress == 2" align="center">
                    <div class="col"
                        v-for="campaignPackage in campaign.packages.filter(p => p.preferences['locality'] == locality && p.preferences['korban_type'] == korbanType)">

                        <label class="border m-2">
                        </label>
                        <label class="border rounded p-4 m-2 w-75" align="center" style="background-color: #ffffff">

                            <div class="row">
                                <div class="col-lg p-5 d-flex align-items-center" align="left">
                                    <h1 class="m-0 font-weight-bold d-none d-lg-block">{{ campaignPackage.name[lang] }}
                                    </h1>
                                    <h2 class="m-0 font-weight-bold d-lg-none">{{ campaignPackage.name[lang] }}</h2>
                                </div>
                                <div class="col-lg-2 col-12 px-5">
                                    <div class="row justify-content-end">
                                        <h4>RM</h4>
                                        <h2>{{ campaignPackage.amount }}</h2>
                                        <h6 v-if="korbanType == 'kambing'" class="mt-sm-3 mt-0">/ekor</h6>
                                        <h6 v-if="korbanType == 'lembu'" class="mt-sm-3 mt-0">/bahagian</h6>
                                    </div>
                                </div>
                                <div class="col-lg-1 col-12 p-5 d-flex align-items-center justify-content-center">
                                    <input type="radio" name="selectedPackage" :value="campaignPackage.id"
                                        v-model="selectedPackage">
                                </div>
                            </div>

                        </label>
                    </div>
                </div>

                <div v-if="progress == 3" align="center">
                    <label class="border rounded p-4 m-2" align="center"
                        style="height: 400px; width: 300px; background-color: #ffffff">
                        <img v-if="korbanType == 'kambing'" class="mt-5 mb-4" src="/img/gambar_kambing_kurban_2024.png">
                        <img>
                        <img v-if="korbanType == 'lembu'" class="mt-5 mb-4" src="/img/gambar_lembu_kurban_2024.png">
                        <p v-if="korbanType == 'kambing'">Berapa bilangan ekor kambing yang anda mahukan?</p>
                        <p v-if="korbanType == 'lembu'">Berapa bilangan bahagian lembu yang anda mahukan?</p>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <button type="button" class="btn btn-outline-secondary" @click="minus"><i
                                        class="fe fe-minus"></i></button>
                            </div>
                            <input class="form-control text-center" type="text" v-model="counter" name="quantity"
                                @blur="counter = Math.abs(counter)">
                            <div class="input-group-append">
                                <button type="button" class="btn btn-outline-secondary" @click="add"><i
                                        class="fe fe-plus"></i></button>
                            </div>
                        </div>
                    </label>
                </div>

                <div v-if="progress == 4">
                    <div class="card mt-4">
                        <div class="card-body border rounded">
                            <div id="identity">
                                <label for="donorDetails" class="font-weight-bold">Butiran Pembayar</label>
                                <div class="form-group">
                                    <label for="name">Nama <span class="text-red">*</span></label>
                                    <input type="text" class="form-control" name="name" id="name" required
                                        v-model="name">
                                </div>

                                <div class="form-group">
                                    <label for="nric">Kad Pengenalan <span class="text-red">*</span></label>
                                    <input type="text" class="form-control" name="nric" id="nric" required
                                        v-model="nric">
                                </div>

                                <div class="form-group">
                                    <label for="email">Emel <span class="text-red">*</span></label>
                                    <input type="email" class="form-control" name="email" id="email" required
                                        v-model="email">
                                </div>

                                <div class="form-group">
                                    <label for="phone">No Telefon (+60 123456789) <span
                                            class="text-red">*</span></label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text">+60</div>
                                        </div>
                                        <input type="number" class="form-control" id="phone" name="phone"
                                            placeholder="123456789" required v-model="phone">
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>Negeri <span class="text-red">*</span></label>
                                    <select class="form-control" name="state" id="state" required v-model="state">
                                        <option class="form-control" value="0" disabled>Select option</option>
                                        <option v-for="state in states" class="form-control" :value="state.id">{{
                                            state.name }}</option>
                                    </select>
                                </div>

                                <div class="form-group">
                                    <label>Negara <span class="text-red">*</span></label>
                                    <select class="form-control" name="country" id="country" required v-model="country">
                                        <option class="form-control" value="0" disabled>Select option</option>
                                        <option class="form-control" value="malaysia" selected>Malaysia</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="progress == 5">
                    <div class="card mt-4">
                        <div class="card-body border rounded">
                            <div class="row">
                                <input type="hidden" name="total_quantity" v-model="totalBahagian">
                                <input type="hidden" name="total_bahagian" v-model="totalBahagian">
                                <div class="col">
                                    <label for="donorDetails" class="font-weight-bold">Butiran Pembayar</label>
                                </div>
                                <div :class="totalBahagian == counter ? 'form-label ' : 'form-label text-danger'"
                                    style="font-size: 15px" align="right">({{ totalBahagian }}/{{ counter }})</div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-sm-9 col-8">
                                                Nama
                                            </div>
                                            <div class="col-sm-3 col-4">
                                                Bahagian/Ekor
                                            </div>
                                        </div>
                                    </div>
                                    <div v-for="(korbanName, index) in korbanNames" class="form-group">
                                        <div class="row">
                                            <div class="col-sm-9 col-8">
                                                <input type="text" class="form-control" name="korban_name[]"
                                                    v-model="korbanNames[index]" required
                                                    style="text-transform: uppercase;">
                                            </div>
                                            <div class="col-sm-3 col-4">
                                                <!-- <input type="number" class="form-control" name="korban_bahagian[]" v-model="korbanBahagian[index]"> -->
                                                <select class="form-control" name="korban_bahagian[]"
                                                    v-model="korbanBahagian[index]">
                                                    <option class="form-control" value="0" disabled>Select option
                                                    </option>
                                                    <option class="form-control" v-for="n in counter" :value="n">{{ n }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-1" align="right">
                                <a class="btn btn-secondary" v-if="korbanNames.length > 1" @click="deletePenama()"><i
                                        class="fe fe-minus"></i> penama</a>
                                <a class="btn btn-secondary" @click="addPenama()"><i class="fe fe-plus"></i> penama</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="progress == 6">
                    <div class="card mt-4">
                        <div class="card-body border rounded">
                            <div id="identity">
                                <label for="donationDetails" class="font-weight-bold">Butiran Pembayaran</label>
                                <div>
                                    <label>Payment Method<span class="text-red">*</span></label>
                                    <div class="payment-method-options" style="display: flex; flex-wrap: wrap;">
                                        <label v-for="(value, key) in paymentSetting.content"
                                            class="payment-method-option"
                                            style="cursor: pointer; width: 200px; height: 100px; overflow: hidden; margin: 5px; box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1); display: flex; align-items: center;">
                                            <input class="m-2" type="radio" :id="key" name="paymentMethod" :value="key"
                                                v-model="paymentMethod" required>
                                            <div
                                                style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: auto">
                                            </div>
                                            <img :src="`/img/${key}.png`" :alt="key.toUpperCase()"
                                                style="width: 150px;height:50px">
                                        </label>
                                    </div>
                                </div>
                                <div>
                                    <label class="mt-2">Payment Merchant<span class="text-red">*</span></label>
                                    <div class="payment-merchant-options" style="display: flex; flex-wrap: wrap;">
                                        <div v-for="(value, key) in paymentMerchants[paymentMethod]" :key="key">
                                            <label class="payment-merchant-option"
                                                style="cursor: pointer; width: 200px; height: 100px; overflow: hidden; margin: 5px; box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1); display: flex; align-items: center;">
                                                <input class="m-2" type="radio" :id="key" name="paymentMerchant"
                                                    :value="value" v-model="paymentMerchant" required>
                                                <div
                                                    style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: auto">
                                                </div>
                                                <img :src="`/img/${value}.png`" :alt="value.toUpperCase()"
                                                    style="width: 150px;height:50px">
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="progress == 7">
                    <div class="card mt-4">
                        <div class="card-body border rounded">
                            <div id="identity">
                                <h2>Lafaz Akad Peserta</h2>
                                <p>Saya mewakilkan kepada MUSLIM CARE MALAYSIA untuk menyempurnakan ibadah Qurban saya
                                    bagi tahun 2024/1445H kerana Allah SWT. Lebihan dari wang tersebut saya izinkan
                                    untuk digunakan bagi tujuan pengurusan dan dakwah.</p>
                            </div>
                        </div>
                    </div>

                    <div class="row p-5">
                        <input type="number" id="campaign_id" name="campaign_id" :value="campaign.id" hidden>
                        <input type="text" id="donor_identity" name="donor_identity" value="real" hidden>
                        <input type="text" id="name" name="name" v-model="name" hidden>
                        <input type="email" id="email" name="email" v-model="email" hidden>
                        <input type="text" id="nric" name="nric" v-model="nric" hidden>
                        <input type="number" id="phone" name="phone" v-model="phone" hidden>
                        <input type="number" id="state" name="state" v-model="state" hidden>
                        <input type="number" id="counter" name="counter" v-model="counter" hidden>
                        <input type="number" id="selectedPackage" name="selectedPackage" v-model="selectedPackage"
                            hidden>
                        <input type="text" id="paymentMethod" name="paymentMethod" v-model="paymentMethod" hidden>
                        <input type="text" id="paymentMerchant" name="paymentMerchant" v-model="paymentMerchant" hidden>
                        <input type="text" name="korban_name[]" v-model="korbanNames" hidden>
                        <input type="text" name="korban_bahagian[]" v-model="korbanBahagian" hidden>


                        <div class="row mt-sm-2 w-75 d-flex flex-nowrap pl-5">
                            <input type="checkbox" name="akad" id="akad" required v-model="akad">
                            <label class="pl-5 pt-sm-2" for="akad">Saya sudah membaca lafaz akad <span
                                    class="text-red">*</span></label>
                        </div>
                        <div class="w-25" align="right">
                            <button type="submit" :disabled="!akad" class="btn btn-md text-white"
                                style="background-color: #216A35; border-radius: 10px;">Bayar</button>
                        </div>
                    </div>
                </div>

            </div>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            name: '',
            email: '',
            nric: '',
            phone: '',
            state: '',
            country: 'malaysia',
            progress: 0,
            percent: 100 / 8,
            korbanType: '',
            locality: '',
            selectedPackage: '',
            counter: 1,
            korbanNames: [''],
            korbanBahagian: [0],
            akad: '',
            paymentMerchant: '',
            paymentMethod: '',
            paymentMerchants: {
                cards: ["senangpay"],
                fpx: ["senangpay", "infaqpay"]
            },
        };
    },
    props: [
        'lang',
        'routeStore',
        'csrf',
        'packages',
        'campaign',
        'states',
        'paymentSetting',
    ],
    computed: {
        totalBahagian() {
            return this.korbanBahagian.map(Number).reduce((a, b) => a + b, 0);
        },
        isDonorCompleted() {
            if (this.name && this.email && this.nric && (this.phone.length == 9 || this.phone.length == 10) && this.state) {
                return true;
            }
            return false;
        },
        isPenamaCompleted() {
            if (this.totalBahagian == this.counter) {
                for (var i = 0; i < this.korbanNames.length; i++) {
                    if (this.korbanNames[i] === "") return false;
                }
                return true;
            }
            return false;
        },
        isPaymentMerchantSelected() {
            if (this.paymentMerchant) {
                return true;
            }
            return false;
        },
        nextButton() {
            if ((this.progress == 0 && !this.korbanType) || (this.progress == 1 && !this.locality) || (this.progress == 2 && !this.selectedPackage) || (this.progress == 4 && !this.isDonorCompleted) || (this.progress == 5 && !this.isPenamaCompleted) || (this.progress == 6 && !this.isPaymentMerchantSelected) || this.progress == 7) {
                return true;
            }
            return false;

        }
    },
    created() {
        this.paymentMethod = Object.keys(this.paymentSetting.content)[0];
    },
    methods: {
        back() {
            if (this.progress != 0) {
                this.progress = this.progress - 1;
                this.percent = this.percent - (100 / 8);
            }
        },
        next() {
            this.progress = this.progress + 1;
            this.percent = this.percent + (100 / 8);
        },
        add(event) {
            event.preventDefault
            this.counter++;
            this.$emit('change-counter', this.counter);
        },
        minus(event) {
            this.counter--;
            if (this.counter < 2) {
                this.counter = 1
            }
            this.$emit('change-counter', this.counter);
        },
        addPenama() {
            this.korbanNames.push('');
            this.korbanBahagian.push(0);
        },
        deletePenama() {
            this.korbanNames.pop();
            this.korbanBahagian.pop();
        },
        onSubmit(e) {
            if (this.progress != 7) {
                e.preventDefault()
            }
        },
        isMobile() {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
    },
    mounted() {
    },
    watch: {
        locality: function (newLocality, oldLocality) {
            this.selectedPackage = '';
        },
        korbanType: function (newKorbanType, oldKorbanType) {
            this.selectedPackage = '';
        },
        counter: function (newCounter, oldCounter) {
            if (isNaN(newCounter)) {
                return
            }

            if (newCounter < 0) {
                newCounter = Math.abs(newCounter)
            }

            this.$emit('change-counter', newCounter);
        }
    }
}
</script>